<template>
    <div v-if="newAccountConnection">
        <account-picker
            v-if="newAccountConnection"
            :account-no="account.bookkeepingAccountNo"
            :accounts="accounts"
            show-bank-info
            open-left
            open-top
            single-pane
            single-pane-show-actions
            :filter-by-search="false"
            data-cy="account-picker"
            @update:account-no="(accountNo: string | undefined) => onUpdateAccountNo(accountNo, account)"
            @on-account-picker-closed="newAccountConnection = false"
        />
    </div>
    <div v-else class="flex items-center gap-2 ">
        <account-link v-if="account.bookkeepingAccountNo && !newAccountConnection" :account-no="account.bookkeepingAccountNo" class="text-primary">
            {{ account.bookkeepingAccountNo }}
        </account-link>
        <div class="grow"/>
        <div>
            <button class="text-primary text-lg i-ph-pencil" data-cy="new-acc-connection" @click="newAccountConnection = true"/>
        </div>
    </div>
</template>

<script setup lang="ts">

import AccountLink from '@/bookkeeping-account/AccountLink.vue'
import AccountPicker from '@/account-picker/AccountPicker.vue'
import {computed, ref} from 'vue'
import {bookkeepingAccounts} from '@/bookkeeping-account/bookkeepingAccount.service'
import {RichBankAccount} from '@/bank/bank.types'
import {assignBankAccount, fetchBankAccounts} from '@/bank/bank-account.service'

defineProps<{
    account: RichBankAccount
}>()

const accounts = computed(() => bookkeepingAccounts.value.filter(ba => {
    const accountNo = Number(ba.accountNo)
    return !isNaN(accountNo) && accountNo >= 1000 && accountNo <= 2999
}))

const newAccountConnection = ref(false)

const onUpdateAccountNo = (accountNo: string | undefined, account: RichBankAccount) => {
    if (!accountNo) return
    assignBankAccount({bookkeepingAccountNo: accountNo, bankAccountUuid: account.uuid})
        .then(fetchBankAccounts)
        .then(() => newAccountConnection.value = false)
}
</script>


<style scoped>

</style>